module.exports = __webpack_public_path__ + "img/webster_fig3.1173efa2.png";